(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("VonageDialer", [], factory);
	else if(typeof exports === 'object')
		exports["VonageDialer"] = factory();
	else
		root["VonageDialer"] = factory();
})(self, () => {
return 